/* Printies generic clicker picker. Tier selection, per-unit option rows driven
   by the product's clicker_options metafield, conditional (showIf) rows, live
   button price, accordion summary lines and the mobile sticky bar.
   No paid extras - the form posts natively to /cart/add. */
(function () {
  var root = document.getElementById("pt-clk");
  var form = document.getElementById("pt-clk-form");
  if (!root || !form) return;

  var bars = root.querySelectorAll(".pt-clk__bar");
  var units = root.querySelectorAll(".pt-clk__unit");
  var btn = root.querySelector(".pt-clk__btn");
  var out = document.getElementById("pt-clk-btnprice");
  var sticky = document.getElementById("pt-clk-sticky");
  var stickyPrice = document.getElementById("pt-clk-stickyprice");
  var stickyBtn = document.getElementById("pt-clk-stickybtn");

  function money(cents) { return "$" + (cents / 100).toFixed(2); }

  function refreshPrice() {
    var sel = root.querySelector(".pt-clk__input:checked");
    if (!sel) return;
    var total = parseInt(sel.dataset.cents, 10) || 0;
    if (out) out.textContent = money(total);
    if (stickyPrice) stickyPrice.textContent = money(total);
  }

  /* Reveal/hide conditional rows for one unit, then disable hidden inputs so
     they never post a property the customer did not actually choose. */
  function refreshConditionals(unitEl) {
    unitEl.querySelectorAll(".pt-clk__row[data-showif-prop]").forEach(function (row) {
      var prop = row.dataset.showifProp;
      var want = row.dataset.showifEq;
      var ctrl = null;
      unitEl.querySelectorAll("input[data-prop]").forEach(function (inp) {
        if (inp.dataset.prop === prop && inp.checked) ctrl = inp;
      });
      var show = !!ctrl && ctrl.value === want;
      row.hidden = !show;
      row.querySelectorAll("input").forEach(function (inp) { inp.disabled = !show; });
    });
  }

  function refreshSummary(i) {
    var el = document.getElementById("pt-clk-sum" + i);
    var unitEl = root.querySelector('.pt-clk__unit[data-unit="' + i + '"]');
    if (!el || !unitEl) return;
    var parts = [];
    unitEl.querySelectorAll(".pt-clk__row").forEach(function (row) {
      if (row.hidden) return;
      var checked = row.querySelector("input:checked");
      if (checked) parts.push(checked.dataset.name || checked.value);
    });
    el.textContent = parts.join(" · ");
  }

  function activate(bar) {
    var count = parseInt(bar.getAttribute("data-units"), 10) || 1;
    bars.forEach(function (b) {
      var on = b === bar;
      b.classList.toggle("is-on", on);
      if (on) b.querySelector(".pt-clk__input").checked = true;
    });
    units.forEach(function (u) {
      var show = (parseInt(u.getAttribute("data-unit"), 10) || 1) <= count;
      u.hidden = !show;
      u.querySelectorAll("input").forEach(function (input) { input.disabled = !show; });
      if (show) refreshConditionals(u);
    });
    refreshPrice();
  }

  bars.forEach(function (b) {
    b.querySelector(".pt-clk__input").addEventListener("change", function () { activate(b); });
  });

  root.addEventListener("change", function (e) {
    var inp = e.target;
    if (!inp.dataset || !inp.dataset.unit) return;
    var i = inp.dataset.unit;
    var unitEl = root.querySelector('.pt-clk__unit[data-unit="' + i + '"]');
    var label = document.getElementById("pt-clk-c" + i + "-" + inp.dataset.rowidx);
    if (label) label.textContent = inp.dataset.name;
    if (unitEl) refreshConditionals(unitEl);
    refreshSummary(i);
  });

  if (sticky && stickyBtn && btn && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) { sticky.hidden = entries[0].isIntersecting; });
    io.observe(btn);
    stickyBtn.addEventListener("click", function () {
      if (form.requestSubmit) form.requestSubmit(); else btn.click();
    });
  }

  var checked = root.querySelector(".pt-clk__input:checked") || root.querySelector(".pt-clk__input");
  if (checked) activate(checked.closest(".pt-clk__bar"));
  units.forEach(function (u) {
    refreshConditionals(u);
    refreshSummary(u.getAttribute("data-unit"));
  });
})();
